import { useState } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { downloadReport, fmtErr } from "../lib/api";
import { PageHeader } from "../components/ModulePage";

const REPORTS = [
  ["monthly_hs", "Monthly H&S Report", "Module RAG summary, inspections, incidents and maintenance performance for the last month."],
  ["fire", "Fire Compliance Report", "Fire tests, walkarounds, equipment, drills, FRAs, certificates and remedial actions."],
  ["puwer", "PUWER Report", "Machine register status and machine safety inspections."],
  ["coshh", "COSHH Report", "Chemical inventory with automatic checks and purchase approvals."],
  ["capa", "Corrective Action Report", "Incident CAPA register and open corrective work orders."],
  ["audit", "Audit Readiness Report", "All red and amber items across every module."],
  ["contractor", "Contractor Performance Report", "Jobs, closures, overdue work and insurance status by contractor."],
  ["legionella", "Legionella Compliance Report", "Water system register, temperature readings against limits, flushing, risk assessments and sampling."],
  ["pathway", "Pathway Audit Report", "Pathway routes, completed walkaround audits and failed checks by area."],
];

export default function Reports() {
  const [busy, setBusy] = useState(null);
  const get = async (k) => {
    setBusy(k);
    try {
      await downloadReport(k);
    } catch (e) {
      toast.error(fmtErr(e));
    } finally {
      setBusy(null);
    }
  };
  return (
    <div>
      <PageHeader eyebrow="Reporting" title="Compliance Reports" description="Download PDF reports generated from live data." />
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {REPORTS.map(([k, t, d]) => (
          <button key={k} onClick={() => get(k)} disabled={!!busy} className="panel group flex items-start gap-4 p-5 text-left transition-colors hover:border-rose-500/60" data-testid={`report-${k}-btn`}>
            {busy === k ? <Loader2 className="h-7 w-7 animate-spin text-rose-400" /> : <FileDown className="h-7 w-7 text-rose-400 transition-transform group-hover:translate-y-0.5" />}
            <span>
              <span className="font-display block text-xl font-bold uppercase">{t}</span>
              <span className="text-sm text-slate-400">{d}</span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
